var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ground-temp"},[_c('div',{staticClass:"banner-wrapper"},[_vm._t("default")],2),_c('h1',[_vm._v("招聘职位")]),_c('Joblist',{ref:"joblist",attrs:{"place":_vm.place,"selector":_vm.selector}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }